import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ArStatementsPageRoutingModule } from './ar-statements-routing.module';

import { ArStatementsRowComponent } from '@payments/components/ar-statements-row/ar-statements-row.component';
import { PaymentsSharedModule } from '@payments/payments-shared/payments-shared.module';
import { SharedModule } from '@shared/shared.module';
import { ArStatementsPage } from './ar-statements.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedModule,
    ArStatementsPageRoutingModule,
    PaymentsSharedModule,
    SharedModule,
  ],
  declarations: [ArStatementsPage, ArStatementsRowComponent],
})
export class ARStatementsPageModule {}
